<template>
  <b-list-group
    class="drag-list"
    @drop.stop="handleDrop($event)"
    @dragover.prevent
  >
    <b-list-group-item
      v-for="(item, index) in items"
      :key="index"
      :ref="`item-${index}`"
      class="drag-list__item"
      draggable
      @dragstart="startItemDrag($event, item, index)"
      @dragenter.prevent="handleDragEnter($event, item, index)"
      @dragleave.prevent="handleDragLeave($event)"
    >
      <div class="drag-list__item__content">
        <slot :item="item"></slot>
      </div>
      
    </b-list-group-item>
  </b-list-group>
</template>

<script>

export default {
  components: {
  },
  props: {
    listItems: { type: Array, required: true }
  },
  data() {
    return {
      dragItem: null,
      dragItemIndex: null,
      items: null,
    }
  },
  computed: {
  },
  watch: {
    listItems(listItems) {
      this.items = listItems;
    }
  },
  mounted() {
    this.items = this.listItems;
  },
  methods: {
    startItemDrag(event, item, index) {
      // setTimeout(() => 
      //   event.target.classList.add("drag-list__item--dragging"), 
      //   0); // hack to apply styles to dragged element without affecting appearance of drag image
      this.dragItem = item;
      this.dragItemIndex = index;
    },
    handleDragEnter(event, item, index) {
      if ( !this.dragItem || this.dragItem === item ) return;

      event.target.classList.add("drag-list__item--dragover");
      
      if (index < this.dragItemIndex) {
        this.items = this.items.slice(0, index).concat(
          [this.dragItem],
          this.items.slice(index, this.dragItemIndex),
          this.items.slice(this.dragItemIndex + 1),  
        );
      } else {
        this.items = this.items.slice(0, this.dragItemIndex).concat(
          this.items.slice(this.dragItemIndex + 1, index + 1),
          [this.dragItem],
          this.items.slice(index + 1),  
        );
      }

      this.dragItemIndex = index;
    },
    handleDragLeave(event) {
      if (event.target.contains(event.relatedTarget)) return; // Don't remove class if child element

      event.target.classList.remove("drag-list__item--dragover");
    },
    handleDrop(event) {
      if (event.target.classList.contains('drag-list__item')) {
        event.target.classList.remove("drag-list__item--dragover");
      } else {
        event.target.closest('.drag-list__item').classList.remove("drag-list__item--dragover");
      }

      this.dragItem = null;
      this.$emit('updateItemsOrder', this.items);
    },
  }
}
</script>

<style lang="scss" scoped>
  .drag-list__item {
    cursor: move;
    // cursor: grab;

    // &:active {
    //   cursor: grabbing !important;
    // }

    &--dragover {
      transform: scale(1.01);
      border-width: 2px;
      border-radius: 4px;
      .drag-list__item__content {
        opacity: 0;
      }
    }
  }
  
</style>